<template lang="pug">
v-container(fluid class="tw-w-full tw-mx-auto")
  v-progress-linear(v-if="loading" indeterminate color="primary")
  v-alert(v-if="!loading && !plansReady" type="info" outlined)
    | Billing plans are not available in this environment.
  div(v-if="plansReady && layout == 'default'")
    v-row(justify="center")
      v-col(cols="auto")
        span(class="h2") Affordable Pricing
    v-row(no-gutters justify="center" class="tw-pt-6")
      v-col(cols="auto")
        p(class=" text-secondary h4") Flexible monthly billing or pay annually to save up to 15%
    v-row(justify="center")
      v-col(cols="auto")
        v-row(align="center")
          v-col(cols="auto")
            span(class="text-secondary") Monthly
          v-col(cols="auto")
            v-switch(v-model="annualBilling" inset :ripple="false")
          v-col(cols="auto")
            span(class="text-secondary") Annual
    v-row(align="center" class="tw-pt-2 tw-w-4/6 tw-mx-auto")
      v-col(class=" pricing-container tw-pt-5 ")
        v-row(no-gutters class="tw-h-full")
          v-col(class="d-flex flex-column ")
            v-row(justify="center")
              v-col(cols="auto" class="tw-text-center")
                div
                  span(class="tw-font-bold tw-uppercase tw-text-blueGray-darken-1 tw-text-lg") {{ starter.name }}
                div(class="tw-pt-4")
                  span(class="tw-font-black tw-text-blueGray-lighten-1 tw-text-lg") {{ starter.description }}
            v-row(justify="center" align="center" class="tw-pt-8")
              v-col(cols="auto" class="pt-3")
                div(v-for="feature in starter.features" class="")
                  v-img(src="@/assets/images/web/check-icon.svg" width="10px" height="10px" class=" d-inline-flex tw-mr-1")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") {{ feature.name }}
            v-row(justify="center" align="end" class=" tw-h-full tw-pb-1 ")
              v-col(v-if="annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ starter.yearly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /year
              v-col(v-if="!annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ starter.monthly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /mo
            v-row(justify="center")
              v-col(cols="auto" align="center")
                v-btn(
                  :disabled="loading"
                  :loading="loading"
                  color="indigo lighten-2"
                  outlined
                  class=""
                  @click="checkout(annualBilling ? starter.yearly.id : starter.monthly.id)"
                )
                  span(class="tw-capitalize tw-font-semibold") Get Started

      v-col(class="pricing-container-featured tw-mx-10 tw-pt-5")
        v-row(no-gutters class="tw-h-full")
          v-col(class="d-flex flex-column ")
            v-row(justify="center")
              v-col(cols="auto" class="tw-text-center")
                div
                  span(class="tw-font-bold tw-uppercase tw-text-blueGray-darken-1 tw-text-lg") professional
                div(class="tw-pt-4")
                  span(class="tw-font-black tw-text-blueGray-lighten-1 tw-text-lg") For 8 users
            v-row(justify="center" align="center" class="tw-pt-8")
              v-col(cols="auto")
                div(class="pb-3")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") Everything on STARTER plus:
                div(v-for="feature in pro.features" class="")
                  v-img(src="@/assets/images/web/check-icon.svg" width="10px" height="10px" class=" d-inline-flex tw-mr-1")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") {{ feature.name }}
            v-row(justify="center" align="end" class=" tw-h-full tw-pb-1 ")
              v-col(v-if="annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ pro.yearly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /year
              v-col(v-if="!annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ pro.monthly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /mo
            v-row(justify="center")
              v-col(cols="auto" align="center")
                v-btn(
                  :disabled="loading"
                  :loading="loading"
                  color="#2f53c9"
                  class=""
                  @click="checkout(annualBilling ? pro.yearly.id : pro.monthly.id)"
                )
                  span(class="tw-capitalize tw-font-semibold") Get Started

      v-col(class=" pricing-container tw-pt-5")
        v-row(no-gutters class="tw-h-full")
          v-col(class="d-flex flex-column ")
            v-row(justify="center")
              v-col(cols="auto" class="tw-text-center")
                div
                  span(class="tw-font-bold tw-uppercase tw-text-blueGray-darken-1 tw-text-lg") enterprise
                div(class="tw-pt-4")
                  span(class="tw-font-black tw-text-blueGray-lighten-1 tw-text-lg") For 20 users
            v-row(justify="center" align="center" class="tw-pt-8")
              v-col(cols="auto")
                div(class="pb-3")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") Everything on PROFESSIONAL plus:
                div(v-for="feature in enterprise.features" class="")
                  v-img(src="@/assets/images/web/check-icon.svg" width="10px" height="10px" class=" d-inline-flex tw-mr-1")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") {{ feature.name }}
            v-row(justify="center" align="end" class=" tw-h-full tw-pb-1 ")
              v-col(v-if="annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ enterprise.yearly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /year
              v-col(v-if="!annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ enterprise.monthly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /mo
            v-row(justify="center")
              v-col(cols="auto" align="center")
                v-btn(
                  :disabled="loading"
                  :loading="loading"
                  color="indigo lighten-2"
                  outlined
                  class=""
                  @click="checkout(annualBilling ? enterprise.yearly.id : enterprise.monthly.id)"
                )
                  span(class="tw-capitalize tw-font-semibold") Get Started

  div(v-if="plansReady && layout == 'register'")
    v-row(justify="center")
      v-col(cols="auto")
        v-row(align="center")
          v-col(cols="auto")
            span(class="text-secondary") Monthly
          v-col(cols="auto")
            v-switch(v-model="annualBilling" inset :ripple="false")
          v-col(cols="auto")
            span(class="text-secondary") Annual
    v-row(no-gutters align="center" class="tw-pt-2 tw-w-full  tw-mx-auto")
      v-col(class=" tw-pt-5 ")
        v-row(no-gutters class="tw-h-full")
          v-col(class="d-flex flex-column tw-pt-5 pricing-container tw-border tw-rounded tw-border-blueGray-lighten-4")
            v-row(justify="center" class="tw-pt-2")
              v-col(cols="auto" class="tw-text-center")
                div
                  span(class="tw-font-bold tw-uppercase tw-text-blueGray-darken-1 tw-text-lg") {{ starter.name }}
                div(class="tw-pt-4")
                  span(class="tw-font-black tw-text-blueGray-lighten-1 tw-text-lg") {{ starter.description }}
            v-row(justify="center" align="center" class="tw-pt-8")
              v-col(cols="auto" class="pt-4")
                div(v-for="feature in starter.features" class=" tw-text-left")
                  v-img(src="@/assets/images/web/check-icon.svg" width="10px" height="10px" class=" d-inline-flex tw-mr-1")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") {{ feature.name }}
            v-row(justify="center" align="end" class=" tw-h-full tw-pb-1 tw-pt-6 ")
              v-col(v-if="annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ starter.yearly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /year
              v-col(v-if="!annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ starter.monthly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /mo
            v-row(justify="center")
              v-col(cols="auto" align="center")
                v-btn(
                  :disabled="loading"
                  :loading="loading"
                  color="indigo lighten-2"
                  outlined
                  class=""
                  @click="checkout(annualBilling ? starter.yearly.id : starter.monthly.id)"
                )
                  span(class="tw-capitalize tw-font-semibold") Get Started

      v-col(
        class="pricing-container-featured tw-border tw-rounded tw-border-blueGray-lighten-4 tw-shadow-md tw-bg-gray-lighten-5 tw-mx-2 tw-pt-5"
      )
        v-row(no-gutters class="tw-h-full tw-pt-2")
          v-col(class="d-flex flex-column ")
            v-row(justify="center")
              v-col(cols="auto" class="tw-text-center")
                div
                  span(class="tw-font-bold tw-uppercase tw-text-blueGray-darken-1 tw-text-lg") professional
                div(class="tw-pt-4")
                  span(class="tw-font-black tw-text-blueGray-lighten-1 tw-text-lg") For 8 users
            v-row(justify="center" align="center" class="tw-pt-8")
              v-col(cols="auto")
                div(class="pb-3")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex tw-leading-tight") Everything on <br> STARTER plus:
                div(v-for="feature in pro.features" class=" tw-text-left tw-pl-2 tw-font-bold")
                  v-img(src="@/assets/images/web/check-icon.svg" width="10px" height="10px" class=" d-inline-flex tw-mr-1")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") {{ feature.name }}
            v-row(justify="center" align="end" class=" tw-h-full tw-pb-1 ")
              v-col(v-if="annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ pro.yearly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /year
              v-col(v-if="!annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ pro.monthly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /mo
            v-row(justify="center")
              v-col(cols="auto" align="center")
                v-btn(
                  :disabled="loading"
                  :loading="loading"
                  color="#2f53c9"
                  class=""
                  @click="checkout(annualBilling ? pro.yearly.id : pro.monthly.id)"
                )
                  span(class="tw-capitalize tw-font-semibold") Get Started

      v-col(class=" pricing-container tw-pt-5 tw-border tw-rounded tw-border-blueGray-lighten-4")
        v-row(no-gutters class="tw-h-full tw-pt-2")
          v-col(class="d-flex flex-column ")
            v-row(justify="center")
              v-col(cols="auto" class="tw-text-center")
                div
                  span(class="tw-font-bold tw-uppercase tw-text-blueGray-darken-1 tw-text-lg") enterprise
                div(class="tw-pt-4")
                  span(class="tw-font-black tw-text-blueGray-lighten-1 tw-text-lg") For 20 users
            v-row(justify="center" align="center" class="tw-pt-8")
              v-col(cols="auto")
                div(class="pb-3")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") Everything on PROFESSIONAL plus:
                div(v-for="feature in enterprise.features" class="")
                  v-img(src="@/assets/images/web/check-icon.svg" width="10px" height="10px" class=" d-inline-flex tw-mr-1")
                  span(class=" tw-text-blueGray-lighten-2 d-inline-flex") {{ feature.name }}
            v-row(justify="center" align="end" class=" tw-h-full tw-pb-1 ")
              v-col(v-if="annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ enterprise.yearly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /year
              v-col(v-if="!annualBilling" class="text-center")
                div(class="d-inline-flex")
                  span(class="text-secondary tw-text-3xl") $
                span(class=" tw-text-4xl tw-font-black") {{ enterprise.monthly.unit_amount / 100 }}
                span(class=" tw-text-blueGray-lighten-3 tw-font-lg") /mo
            v-row(justify="center")
              v-col(cols="auto" align="center")
                v-btn(
                  :disabled="loading"
                  :loading="loading"
                  color="indigo lighten-2"
                  outlined
                  class=""
                  @click="checkout(annualBilling ? enterprise.yearly.id : enterprise.monthly.id)"
                )
                  span(class="tw-capitalize tw-font-semibold") Get Started
</template>
<script>
export default {
  props: {
    layout: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      loading: false,
      annualBilling: true,
      enterprise: null,
      pro: null,
      starter: null,
    };
  },

  computed: {
    plansReady() {
      return [this.starter, this.pro, this.enterprise].every(
        (plan) => plan && plan.monthly && plan.yearly && Array.isArray(plan.features)
      );
    },
    starterMonthly() {
      return process.env.VUE_APP_SUBSCRIPTIONS_STARTER_MONTHLY;
    },
    starterAnnual() {
      return process.env.VUE_APP_SUBSCRIPTIONS_STARTER_ANNUAL;
    },
    professionalMonthly() {
      return process.env.VUE_APP_SUBSCRIPTIONS_PROFESSIONAL_MONTHLY;
    },
    professionalAnnual() {
      return process.env.VUE_APP_SUBSCRIPTIONS_PROFESSIONAL_ANNUAL;
    },
    enterpriseMonthly() {
      return process.env.VUE_APP_SUBSCRIPTIONS_ENTERPRISE_MONTHLY;
    },
    enterpriseAnnual() {
      return process.env.VUE_APP_SUBSCRIPTIONS_ENTERPRISE_ANNUAL;
    },
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    getProducts() {
      this.loading = true;
      this.$store.dispatch('checkout/getProducts').then((r) => {
        const products = Array.isArray(r) ? r : [];
        products.forEach((price) => {
          if (price.name == 'Enterprise') {
            price.prices.data.forEach((cycle) => {
              if (cycle.recurring.interval == 'month') {
                price.monthly = cycle;
              }
              if (cycle.recurring.interval == 'year') {
                price.yearly = cycle;
              }
            });
            this.enterprise = price;
          }
          if (price.name == 'PRO') {
            price.prices.data.forEach((cycle) => {
              if (cycle.recurring.interval == 'month') {
                price.monthly = cycle;
              }
              if (cycle.recurring.interval == 'year') {
                price.yearly = cycle;
              }
            });
            this.pro = price;
          }
          if (price.name == 'Starter') {
            price.prices.data.forEach((cycle) => {
              if (cycle.recurring.interval == 'month') {
                price.monthly = cycle;
              }
              if (cycle.recurring.interval == 'year') {
                price.yearly = cycle;
              }
            });
            this.starter = price;
          }
        });
        this.loading = false;
      });
    },
    async checkout(item) {
      this.loading = true;
      const authUser = await this.$store.dispatch('auth/getAuthUser');
      if (!authUser) {
        this.$store.commit('checkout/SET_CHECKOUT_LINK', item);
        this.$router.push({ name: 'Register' });
        return;
      } else {
        this.$store.dispatch('checkout/getCheckoutLink', item).then((response) => {
          this.loading = false;
          console.log('checkout link clicked', item);
          console.log('checkout link response: ' + response);
          window.location.href = response;
        });
      }
    },
  },
};
</script>
